import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import { awardsInfo } from '../../../../../utils/awardsInfo';
import BowSection from '../BowSection';

export default class Header extends PureComponent {
	static propTypes = {
		awardType: PropTypes.object.isRequired,
		category: PropTypes.object.isRequired,
		headerOnly: PropTypes.bool,
		searchDoneNoPaidResults: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		headerOnly: false,
	};

	contentOptions = () => {
		const { searchDoneNoPaidResults, category, awardType } = this.props;
		const { bow } = awardsInfo();
		let opts = {};

		if (searchDoneNoPaidResults) {
			opts = {
				title: 'No Results',
				body: (
					<p>
						We couldn&apos;t find any results for &quot;
						<strong>{category.name}</strong>
						&quot; in your area, but you might try selecting another vendor
						category!
					</p>
				),
			};
		} else if (awardType.slug === bow.slug) {
			opts = {
				title: `${bow.name} Winners - ${category.name}`,
				body: (
					<p>
						The Knot Best of Weddings is an annual award that recognizes the top
						wedding vendors across the country. This prestigious honor
						represents the highest rated vendors on The Knot who are trusted,
						dependable, and deliver quality service.
					</p>
				),
			};
		} else {
			opts = {
				title: `Hall of Fame Inductees - ${category.name}`,
				body: (
					<p>
						The Knot Best of Weddings Hall of Fame recognizes exceptional
						wedding professionals who have consistently delivered quality
						service. Only wedding vendors who have earned four or more of The
						Knot Best of Weddings awards are inducted into the Hall of Fame.
					</p>
				),
			};
		}
		return opts;
	};

	render() {
		const { title, body } = this.contentOptions();
		const sectionProps = {
			title,
		};

		if (!this.props.headerOnly) {
			sectionProps.body = body;
		}

		return <BowSection {...sectionProps} />;
	}
}
